import { BaseTask } from "@jugl-web/rest-api/tasks";
import { useCallback, useMemo } from "react";

export type RequiredTaskFields = Pick<
  BaseTask,
  "board_id" | "assignees" | "created_by"
>;

export interface TaskRoleFlags {
  isTaskCreator: boolean;
  isTaskAssignee: boolean;
}

interface UseTaskRolesFactoryOptions {
  entityId: string;
  meId: string | undefined;
}

const DEFAULT_TASK_ROLE_FLAGS: TaskRoleFlags = {
  isTaskCreator: false,
  isTaskAssignee: false,
};

export const useTaskRolesFactory = ({ meId }: UseTaskRolesFactoryOptions) => {
  const getTaskRoles = useCallback(
    (task: RequiredTaskFields) => {
      const isTaskCreator = task.created_by === meId;

      const isTaskAssignee = task.assignees.some(
        (assigneeId) => assigneeId === meId
      );

      return {
        isTaskCreator,
        isTaskAssignee,
      };
    },
    [meId]
  );

  return getTaskRoles;
};

interface UseTaskRolesOptions extends UseTaskRolesFactoryOptions {
  task: RequiredTaskFields | undefined;
}

export const useTaskRoles = (options: UseTaskRolesOptions) => {
  const getTaskRoles = useTaskRolesFactory(options);

  const taskRoles = useMemo(
    () => (options.task ? getTaskRoles(options.task) : DEFAULT_TASK_ROLE_FLAGS),
    [getTaskRoles, options.task]
  );

  return taskRoles;
};
